export const TEXT_INPUT_TYPE = 'text';
export const NAME_LABEL = $localize`Name`;
export const EMAIL_INPUT_TYPE = 'email';
export const EMAIL_LABEL = $localize`Email`;
export const MAIL_ICON = 'mail';
export const PHN_LABEL = $localize`Phone Number`;
export const PHN_STYLE = 'example-full-width';
export const PHN_ICON = 'smartphone';
export const ORGNAME_LABEL = $localize`Organization Name`;
export const ACCOUNT_CIRCLE_ICON = 'account_circle';
export const ORGNAME_PLACEHOLDER = 'Google';
